<script lang="ts">
	import { concatGoals } from '../hockeydata.js';
	import type { HDTeam } from '../types/responses/DivisionInfo.js';
	import type {
		HDStandingsResponse,
		HDStandingsResponseData
	} from '../types/responses/Standings.js';
	import type { HDTeamDetailsResponseData } from '../types/responses/TeamDetails.js';

	const {
		team,
		teamImage,
		standings
	}: { team: HDTeamDetailsResponseData; teamImage: string; standings: HDStandingsResponseData } =
		$props();

	const standingsRow = $derived(standings.rows.find((row) => row.id === team.teamData.id)!!);
	const rank = $derived(standingsRow?.tableRank ?? 0);
	const pointsToNext = $derived.by(() => {
		if (rank === 1) {
			return undefined;
		}
		const requiredPoints = standings.rows.find((row) => row.tableRank === rank - 1)?.points ?? 0;
		return requiredPoints - standingsRow.points;
	});
</script>

<div class="bg-base-100 flex min-w-0 flex-wrap items-center gap-4 p-4 sm:p-6">
	<div class="w-20 shrink-0 sm:w-32">
		<img src={teamImage} alt={`${team.teamData.teamLongname} Logo`} class="" />
	</div>
	<div class="flex min-w-0 flex-1 flex-col">
		<div class="text-2xl font-black tracking-wider wrap-anywhere uppercase sm:text-5xl">
			{team.teamData.teamShortname}
		</div>
	</div>
	<div
		class="text-base-content mr-0 ml-auto flex w-full flex-col text-end text-lg font-bold sm:w-auto"
	>
		<div class="text-base-content text-5xl font-black tracking-wider md:text-7xl">
			<span class="mr-4 italic">#</span>{rank}
		</div>
		{#if rank > 1}
			<div>
				{pointsToNext} Punkt{pointsToNext !== 1 ? 'e' : ''} hinter
				<span class="mr-1 italic">#</span>{rank - 1}
			</div>
		{/if}
	</div>
</div>
